import React from 'react';
import { connect } from "react-redux";
import { } from '../../action/user';
import { selectSessionBranch, getCustomAttributeSession } from '../../action/session';
import { toggleSelect } from '../../action/view';
import * as Constants from '../../Constants';

function mapStateToProps(state) {
    return state;
}

const mapDispatchToProps = {
    selectSessionBranch,
    toggleSelect
};
class SelectBranch extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            searchBranches: this.props.branchView.branchList.filter(function (branch) {
                return branch.deleted_at === null;
            }),
            branches: this.props.branchView.branchList.filter(function (branch) {
                return branch.deleted_at === null;
            }),
            sessionBranch: this.props.sessionView.session.branch ? this.props.sessionView.session.branch : {}
        }
    }

    toggleSelect(e) {
        e.preventDefault();
        this.props.toggleSelect();
    }

    selectBranch(e) {
        if (Object.keys(this.state.sessionBranch).length > 0) {
            this.props.selectSessionBranch(this.state.sessionBranch);

            let activity_id = '';
            if (this.props.sessionView.session.activity_type_id) {
                activity_id = this.props.sessionView.session.activity_type_id
            }
        }
        this.props.toggleSelect();
    }

    search(e) {
        let searchBranches = []
        for (var i = 0; i < this.state.branches.length; i++) {
            let branchName = this.state.branches[i].name;
            if (branchName.toLowerCase().includes(e.currentTarget.value.toLowerCase())) {
                searchBranches.push(this.state.branches[i]);
            }
        }
        this.setState({
            searchBranches: searchBranches,
            branches: this.state.branches,
            sessionBranch: this.state.sessionBranch
        });
    }

    toggleOneBranch(e) {
        let branchId = e.currentTarget.getAttribute('data-id');

        let sessionBranch = {};
        for (var i = 0; i < this.state.branches.length; i++) {
            if (this.state.branches[i].id === parseInt(branchId)) {
                sessionBranch = this.state.branches[i];
                break;
            }
        }
        this.setState({
            searchBranches: this.state.searchBranches,
            branches: this.state.branches,
            sessionBranch: sessionBranch
        });
    }

    render() {
        const branches = this.state.searchBranches.map((branch, key) => {
            let branchClass = '';
            if (branch.id === this.state.sessionBranch.id) {
                branchClass = 'active';
            }

            return (
                <div className="item-name" key={branch.id} data-id={branch.id}>
                    {branch.name}
                    <div className="float-right round-checkbox" data-id={branch.id} onClick={this.toggleOneBranch.bind(this)}>
                        <div className={branchClass}></div>
                    </div>
                </div>
            );
        });
        return (
            <div className="session select-div normal-box">
                <div className="normal-margin" >
                    <h1 className="clickable" onClick={this.toggleSelect.bind(this)}><img src="/img/arrow-left.svg" alt="Arrow Left" className="arrow-left"></img>Select Club</h1>
                    <div className="search-field">
                        <input placeholder="Search Clubs" onChange={this.search.bind(this)}></input>
                        <img src="/img/search-icon.svg" alt="Search Icon" className="search-icon"></img>
                    </div>
                    {branches}
                    <button className="red-white-button" onClick={this.selectBranch.bind(this)}>Select</button>
                </div>
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SelectBranch);
